import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Answer, GeneralContent, GetAllDataRes, Question } from "../../types";
import axios from "axios";
// Define a type for the slice state
export const BASE_URL =
  "https://script.google.com/macros/s/AKfycbwgFysRKVnaBjq9NCzfDHMhOiHJv5pwfDdKjM0RHOgGjGbv-DVBH9ZuJlD-GHDDefUwEg/exec";
export const WEBHOOK_URL = "https://go.infotrust.com.au/l/939373/2022-05-11/254pr"

export const fetchAllData = createAsyncThunk(
  "quiz/allData",
  async (thunkAPI) => {
    const res = await axios.get<GetAllDataRes>(BASE_URL);
    return res.data;
  }
);

const initialState = {
  questions: [] as Question[],
  answers: {} as Record<string, Answer>,
  generalContent: null as GeneralContent | null,
  ended: false,
  requestStatus: {
    isLoading: false,
    isError: false,
    error: null,
  },
};

export const quizSlice = createSlice({
  name: "Questions",
  initialState,
  reducers: {
    addAnswer: (state, action: PayloadAction<Record<string, Answer>>) => {
      state.answers = { ...state.answers, ...action.payload };
    },
    endQuiz: (state) => {
      state.ended = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllData.pending, (state, action) => {
      state.requestStatus.isLoading = true;
    });

    builder.addCase(fetchAllData.fulfilled, (state, action) => {
      state.questions = action.payload.questions;
      state.generalContent = action.payload.generalContent;

      state.requestStatus.isLoading = false;
    });

    builder.addCase(fetchAllData.rejected, (state, action) => {
      state.requestStatus.isLoading = false;
      state.requestStatus.isError = false;
      state.requestStatus.error = action.error as any;
    });
  },
});

export const { addAnswer, endQuiz } = quizSlice.actions;
